webpackJsonp([1],{

/***/ "/W6S":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Tiles_vue__ = __webpack_require__("rhJX");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_debe4ada_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Tiles_vue__ = __webpack_require__("toJh");
function injectStyle (ssrContext) {
  __webpack_require__("iMhh")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-debe4ada"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Tiles_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_debe4ada_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Tiles_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "1Dap":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NotFound_vue__ = __webpack_require__("kdTb");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7ef3dc1b_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NotFound_vue__ = __webpack_require__("d1sA");
function injectStyle (ssrContext) {
  __webpack_require__("vYcq")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-7ef3dc1b"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NotFound_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7ef3dc1b_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NotFound_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "5QPK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"page"}},[_c('site-header',{attrs:{"title":"Terms of Service"}}),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('site-footer')],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content-row"},[_c('h4',[_vm._v("\n         Terms of Service\n         "),_c('br'),_vm._v("Effective date: May 3rd, 2020\n      ")]),_vm._v(" "),_c('p',[_vm._v("\n         If you have a separate written agreement with Company Inc., then the updates to the Terms of Service will not apply to you.\n      ")]),_vm._v(" "),_c('p',[_vm._v("\n         By accessing or using the Commentoid website, the Commentoid service, or any applications (including mobile applications) made available by Commentoid (together, the \"Service\"), however accessed, you agree to be bound by these terms of service (\"Terms of Service\"). The Service is owned or controlled by Company, Inc. (\"Company\"). These Terms of Service affect your legal rights and obligations. If you do not agree to be bound by all of these Terms of Service, do not access or use the Service.\n      ")]),_vm._v(" "),_c('p',[_vm._v("\n         There may be times when we offer a special feature that has its own terms and conditions that apply in addition to these Terms of Use. In those cases, the terms specific to the special feature control to the extent there is a conflict with these Terms of Use.\n      ")]),_vm._v(" "),_c('p',[_vm._v("\n         Commentoid is a software as a service (\"SaaS\") platform. Our software services facilitate business workflow applications that are capable of integrating with other business systems. The Commentoid service is provided over mobile, web-based and desktop applications.\n      ")]),_vm._v(" "),_c('p',[_vm._v(" \n         In these Terms of Service (\"Terms\"), \"we\", \"us\", \"our\", \"Commentoid\", \"Company\" will refer to Company Inc. and the terms \"you\", \"your\" and \"Customer\" will refer to you.\n      ")]),_vm._v(" "),_c('h3',[_vm._v(" Acceptable Use Policy ")]),_vm._v(" "),_c('p',[_vm._v("\n         We may revise these Terms from time to time. If we do, those revised Terms will supersede prior versions. Unless we say otherwise, revisions will be effective upon the effective date indicated at the top of these Terms. Thus, you agree not to use, and not to encourage or allow any end user to use, the Service in the following prohibited ways:\n      ")]),_vm._v(" "),_c('ol',{staticClass:"sub-list-1"},[_c('li',[_vm._v("\n            Any illegal, fraudulent, abusive, or other activities that materially interfere with the business or activities of Company.\n         ")]),_vm._v(" "),_c('li',[_vm._v("\n            Attempting to bypass or break any security mechanism on any of the Service or using the Service in any other manner that poses a material security or service risk to Company or any of its customers.\n         ")]),_vm._v(" "),_c('li',[_vm._v("\n            Reverse-engineering the Service in order to find limitations, vulnerabilities, or evade filtering capabilities.\n         ")]),_vm._v(" "),_c('li',[_vm._v("               \n            Launching or facilitating, whether intentionally or unintentionally, a denial of service attack on any of the Service or any other conduct that materially and adversely impacts the availability, reliability, or stability of the Service.\n         ")]),_vm._v(" "),_c('li',[_vm._v("               \n            Transmitting any material that contains viruses, Trojan horses, spyware, worms or any other malicious, harmful, or deleterious programs.\n         ")]),_vm._v(" "),_c('li',[_vm._v("\n            Engaging in any unsolicited advertising, marketing or other activities prohibited by applicable law or regulation covering anti-spam, data protection, or privacy legislation in any applicable jurisdiction.\n         ")]),_vm._v(" "),_c('li',[_vm._v("\n            Using the Service in connection with unsolicited, unwanted, or harassing communications (commercial or otherwise).\n         ")]),_vm._v(" "),_c('li',[_vm._v("\n            Using the Service to harvest or otherwise collect information about individuals, including email addresses or phone numbers, without their explicit consent or under false pretenses.\n         ")]),_vm._v(" "),_c('li',[_vm._v("\n            Using the Service to engage in, or in connection with any illegal or fraudulent activity.\n         ")]),_vm._v(" "),_c('li',[_vm._v("\n            Using the Service to receive, send or otherwise process Protected Health Information as defined by the Health Insurance Portability and Accountability Act of 1996 as amended, unless you have signed a Business Associate Agreement with Company or your use of the Service fits within the “conduit” or some other exception for requiring a Business Associate Agreement.\n         ")]),_vm._v(" "),_c('li',[_vm._v("\n            Violating or facilitating the violation of any local, state, federal, or foreign law or regulation, including, but not limited to, laws and regulations regarding the transmission of data or software.\n         ")]),_vm._v(" "),_c('li',[_vm._v("\n            Using the Service in a manner that triggers a law enforcement, government, or regulatory agency to request the suspension of the Service to you.\n         ")]),_vm._v(" "),_c('li',[_vm._v("\n            Using the Service to transmit any material that infringes the intellectual property rights or other rights of third parties.\n         ")]),_vm._v(" "),_c('li',[_vm._v("\n            Using the Service to transmit any material that is, facilitates, or encourages libelous, defamatory, discriminatory, or otherwise malicious or harmful speech or acts to any person or entity, including but not limited to hate speech, and any other material that Company reasonably believes degrades, intimidates, incites violence against, or encourages prejudicial action against anyone based on age, gender, race, ethnicity, national origin, religion, sexual orientation, disability, geographic location or other protected category.\n         ")]),_vm._v(" "),_c('li',[_vm._v("\n            Using the Service to transmit any material or content that is offensive, inappropriate, pornographic, obscene, illegal, or otherwise objectionable to any person or entity.\n         ")])]),_vm._v(" "),_c('h3',[_vm._v(" Responsibilities ")]),_vm._v(" "),_c('p',[_vm._v("\n         You are responsible for any activity that occurs through your account and you agree you will not sell, transfer, license or assign your account, any account rights. With the exception of people or businesses that are expressly authorized to create accounts on behalf of their employers or clients, Company prohibits the creation of and you agree that you will not create an account for anyone other than yourself. You also represent that all information you provide or provided to Company upon registration and at all other times will be true, accurate, current and complete and you agree to update your information as necessary to maintain its truth and accuracy.\n      ")]),_vm._v(" "),_c('p',[_vm._v("\n         You agree that you will not solicit, collect or use the login credentials of other Commentoid users.\n      ")]),_c('p'),_c('p',[_vm._v("            \n         You are responsible for keeping your password secret and secure.\n      ")]),_vm._v(" "),_c('p',[_vm._v("            \n         You may not use the Service for any illegal or unauthorized purpose. You agree to comply with all laws, rules and regulations (for example, federal, state, local and provincial) applicable to your use of the Service and your Content (defined below), including but not limited to, copyright laws.\n      ")]),_vm._v(" "),_c('p',[_vm._v("            \n         You are solely responsible for your conduct and any data, text, files, information, usernames, images, graphics, photos, profiles, audio and video clips, sounds, musical works, works of authorship, applications, links and other content or materials (collectively, \"Content\") that you submit, upload or share on or via the Service.\n      ")]),_vm._v(" "),_c('p',[_vm._v("\n         You must not change, modify, adapt or alter the Service or change, modify or alter another website so as to falsely imply that it is associated with the Service or Company.\n      ")]),_vm._v(" "),_c('p',[_vm._v("            \n         You must not access Commentoid's public and/or private API by means other than those permitted by Company.\n      ")]),_vm._v(" "),_c('p',[_vm._v("            \n         You must not interfere or disrupt the Service or servers or networks connected to the Service, including by transmitting any worms, viruses, spyware, malware or any other code of a destructive or disruptive nature. You may not inject content or code or otherwise alter or interfere with the way any Commentoid page is rendered or displayed in a user's browser or device.\n      ")]),_vm._v(" "),_c('p',[_vm._v("\n         Violation of these Terms of Use may, in Company's sole discretion, result in termination of your Commentoid account. You understand and agree that Company cannot and will not be responsible for the Content posted on the Service and you use the Service at your own risk. If you violate the letter or spirit of these Terms of Use, or otherwise create risk or possible legal exposure for Company, we can stop providing all or part of the Service to you.\n      ")]),_vm._v(" "),_c('p',[_vm._v("\n         The Commentoid name and logo are trademarks of Company, and may not be copied, imitated or used, in whole or in part, without the prior written permission of Company. In addition, all page headers, page component and navigation layouts, custom graphics, button icons and scripts are service marks, trademarks and/or trade dress of Commentoid and Company, and may not be copied, imitated or used, in whole or in part, without prior written permission from Company.\n      ")]),_vm._v(" "),_c('h3',[_vm._v(" Service ")]),_vm._v(" "),_c('p',[_vm._v("\n         Although it is Company's intention for the Service to be available as much as possible, there will be occasions when the Service may be interrupted, including, without limitation, for scheduled maintenance or upgrades, for emergency repairs, or due to failure of telecommunications links and/or equipment. Also, Company reserves the right to remove any Content from the Service for any reason, without prior notice. Content removed from the Service may continue to be stored by Company, including, without limitation, in order to comply with certain legal obligations, but may not be retrievable without a valid court order. Consequently, Company encourages you to maintain your own backup of your Content. In other words, Commentoid is not a backup service and you agree that you will not rely on the Service for the purposes of Content backup or storage. Company will not be liable to you for any modification, suspension, or discontinuation of the Service, or the loss of any Content. You also acknowledge that the Internet may be subject to breaches of security and that the submission of Content or other information may not be secure.            \n      ")]),_vm._v(" "),_c('p',[_vm._v("\n         You agree that Company is not responsible for, and does not endorse, Content posted within the Service. Company does not have any obligation to prescreen, monitor, edit, or remove any Content. If your Content violates these Terms of Use, you may bear legal responsibility for that Content.\n      ")]),_vm._v(" "),_c('p',[_vm._v("\n         You acknowledge and agree that your relationship with Company is not a confidential, fiduciary, or other type of special relationship, and that your decision to submit any Content does not place Company in a position that is any different from the position held by members of the general public, including with regard to your Content. None of your Content will be subject to any obligation of confidence on the part of Company, and Company will not be liable for any use or disclosure of any Content you provide.\n      ")]),_vm._v(" "),_c('p',[_vm._v("\n         It is Company's policy not to accept or consider content, information, ideas, suggestions or other materials other than those we have specifically requested and to which certain specific terms, conditions and requirements may apply. This is to avoid any misunderstandings if your ideas are similar to those we have developed or are developing independently. Accordingly, Company does not accept unsolicited materials or ideas, and takes no responsibility for any materials or ideas so transmitted. If, despite our policy, you choose to send us content, information, ideas, suggestions, or other materials, you further agree that Company is free to use any such content, information, ideas, suggestions or other materials, for any purposes whatsoever, including, without limitation, developing and marketing products and services, without any liability or payment of any kind to you.\n      ")]),_vm._v(" "),_c('h3',[_vm._v(" Disclaimer of Warranties ")]),_vm._v(" "),_c('p',[_vm._v("\n         COMMENTOID SERVICES, INCLUDING, WITHOUT LIMITATION, Company CONTENT, IS PROVIDED ON AN \"AS IS\", \"AS AVAILABLE\" AND \"WITH ALL FAULTS\" BASIS. TO THE FULLEST EXTENT PERMISSIBLE BY LAW, NEITHER Company NOR ITS RELATED ENTITIES NOR ANY OF THEIR EMPLOYEES, MANAGERS, OFFICERS OR AGENTS (COLLECTIVELY, THE \"Company PARTIES\") MAKE ANY REPRESENTATIONS OR WARRANTIES OR ENDORSEMENTS OF ANY KIND WHATSOEVER, EXPRESS OR IMPLIED, AS TO: (A) THE SERVICE; (B) THE Company CONTENT; (C) USER CONTENT; OR (D) SECURITY ASSOCIATED WITH THE TRANSMISSION OF INFORMATION TO Company OR VIA THE SERVICE. IN ADDITION, THE Company PARTIES HEREBY DISCLAIM ALL WARRANTIES, EXPRESS OR IMPLIED, INCLUDING, BUT NOT LIMITED TO, THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE, NON-INFRINGEMENT, TITLE, CUSTOM, TRADE, QUIET ENJOYMENT, SYSTEM INTEGRATION AND FREEDOM FROM COMPUTER VIRUS.\n      ")]),_vm._v(" "),_c('p',[_vm._v("\n         THE Company PARTIES DO NOT REPRESENT OR WARRANT THAT THE SERVICE WILL BE ERROR-FREE OR UNINTERRUPTED; THAT DEFECTS WILL BE CORRECTED; OR THAT THE SERVICE OR THE SERVER THAT MAKES THE SERVICE AVAILABLE IS FREE FROM ANY HARMFUL COMPONENTS, INCLUDING, WITHOUT LIMITATION, VIRUSES. THE Company PARTIES DO NOT MAKE ANY REPRESENTATIONS OR WARRANTIES THAT THE INFORMATION (INCLUDING ANY INSTRUCTIONS) ON THE SERVICE IS ACCURATE, COMPLETE, OR USEFUL. YOU ACKNOWLEDGE THAT YOUR USE OF THE SERVICE IS AT YOUR SOLE RISK. THE Company PARTIES DO NOT WARRANT THAT YOUR USE OF THE SERVICE IS LAWFUL IN ANY PARTICULAR JURISDICTION, AND THE Company PARTIES SPECIFICALLY DISCLAIM SUCH WARRANTIES. SOME JURISDICTIONS LIMIT OR DO NOT ALLOW THE DISCLAIMER OF IMPLIED OR OTHER WARRANTIES SO THE ABOVE DISCLAIMER MAY NOT APPLY TO YOU TO THE EXTENT SUCH JURISDICTION'S LAW IS APPLICABLE TO YOU AND THESE TERMS OF USE.\n      ")]),_vm._v(" "),_c('p',[_vm._v("\n         BY ACCESSING OR USING THE SERVICE YOU REPRESENT AND WARRANT THAT YOUR ACTIVITIES ARE LAWFUL IN EVERY JURISDICTION WHERE YOU ACCESS OR USE THE SERVICE.             \n      ")]),_vm._v(" "),_c('p',[_vm._v("\n         THE Company PARTIES DO NOT ENDORSE CONTENT AND SPECIFICALLY DISCLAIM ANY RESPONSIBILITY OR LIABILITY TO ANY PERSON OR ENTITY FOR ANY LOSS, DAMAGE (WHETHER ACTUAL, CONSEQUENTIAL, PUNITIVE OR OTHERWISE), INJURY, CLAIM, LIABILITY OR OTHER CAUSE OF ANY KIND OR CHARACTER BASED UPON OR RESULTING FROM ANY CONTENT.            \n      ")]),_vm._v(" "),_c('h3',[_vm._v(" Limitation of Liability; Waiver ")]),_vm._v(" "),_c('p',[_vm._v("\n         UNDER NO CIRCUMSTANCES WILL THE Company PARTIES BE LIABLE TO YOU FOR ANY LOSS OR DAMAGES OF ANY KIND (INCLUDING, WITHOUT LIMITATION, FOR ANY DIRECT, INDIRECT, ECONOMIC, EXEMPLARY, SPECIAL, PUNITIVE, INCIDENTAL OR CONSEQUENTIAL LOSSES OR DAMAGES) THAT ARE DIRECTLY OR INDIRECTLY RELATED TO: (A) THE SERVICE; (B) THE Company CONTENT; (C) USER CONTENT; (D) YOUR USE OF, INABILITY TO USE, OR THE PERFORMANCE OF THE SERVICE; (E) ANY ACTION TAKEN IN CONNECTION WITH AN INVESTIGATION BY THE Company PARTIES OR LAW ENFORCEMENT AUTHORITIES REGARDING YOUR OR ANY OTHER PARTY'S USE OF THE SERVICE; (F) ANY ACTION TAKEN IN CONNECTION WITH COPYRIGHT OR OTHER INTELLECTUAL PROPERTY OWNERS; (G) ANY ERRORS OR OMISSIONS IN THE SERVICE'S OPERATION; OR (H) ANY DAMAGE TO ANY USER'S COMPUTER, MOBILE DEVICE, OR OTHER EQUIPMENT OR TECHNOLOGY INCLUDING, WITHOUT LIMITATION, DAMAGE FROM ANY SECURITY BREACH OR FROM ANY VIRUS, BUGS, TAMPERING, FRAUD, ERROR, OMISSION, INTERRUPTION, DEFECT, DELAY IN OPERATION OR TRANSMISSION, COMPUTER LINE OR NETWORK FAILURE OR ANY OTHER TECHNICAL OR OTHER MALFUNCTION, INCLUDING, WITHOUT LIMITATION, DAMAGES FOR LOST PROFITS, LOSS OF GOODWILL, LOSS OF DATA, WORK STOPPAGE, ACCURACY OF RESULTS, OR COMPUTER FAILURE OR MALFUNCTION, EVEN IF FORESEEABLE OR EVEN IF THE Company PARTIES HAVE BEEN ADVISED OF OR SHOULD HAVE KNOWN OF THE POSSIBILITY OF SUCH DAMAGES, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE, STRICT LIABILITY OR TORT (INCLUDING, WITHOUT LIMITATION, WHETHER CAUSED IN WHOLE OR IN PART BY NEGLIGENCE, ACTS OF GOD, TELECOMMUNICATIONS FAILURE, OR THEFT OR DESTRUCTION OF THE SERVICE). IN NO EVENT WILL THE Company PARTIES BE LIABLE TO YOU OR ANYONE ELSE FOR LOSS, DAMAGE OR INJURY, INCLUDING, WITHOUT LIMITATION, DEATH OR PERSONAL INJURY. SOME STATES DO NOT ALLOW THE EXCLUSION OR LIMITATION OF INCIDENTAL OR CONSEQUENTIAL DAMAGES, SO THE ABOVE LIMITATION OR EXCLUSION MAY NOT APPLY TO YOU. IN NO EVENT WILL THE Company PARTIES TOTAL LIABILITY TO YOU FOR ALL DAMAGES, LOSSES OR CAUSES OR ACTION EXCEED ONE HUNDRED CANADIAN DOLLARS ($100.00).\n      ")]),_vm._v(" "),_c('p',[_vm._v("\n         YOU AGREE THAT IN THE EVENT YOU INCUR ANY DAMAGES, LOSSES OR INJURIES THAT ARISE OUT OF Company'S ACTS OR OMISSIONS, THE DAMAGES, IF ANY, CAUSED TO YOU ARE NOT IRREPARABLE OR SUFFICIENT TO ENTITLE YOU TO AN INJUNCTION PREVENTING ANY EXPLOITATION OF ANY WEB SITE, SERVICE, PROPERTY, PRODUCT OR OTHER CONTENT OWNED OR CONTROLLED BY THE Company PARTIES, AND YOU WILL HAVE NO RIGHTS TO ENJOIN OR RESTRAIN THE DEVELOPMENT, PRODUCTION, DISTRIBUTION, ADVERTISING, EXHIBITION OR EXPLOITATION OF ANY WEB SITE, PROPERTY, PRODUCT, SERVICE, OR OTHER CONTENT OWNED OR CONTROLLED BY THE Company PARTIES. \n      ")]),_vm._v(" "),_c('p',[_vm._v("\n         BY ACCESSING THE SERVICE, YOU UNDERSTAND THAT YOU MAY BE WAIVING RIGHTS WITH RESPECT TO CLAIMS THAT ARE AT THIS TIME UNKNOWN OR UNSUSPECTED.\n      ")]),_vm._v(" "),_c('p',[_vm._v("\n         Company IS NOT RESPONSIBLE FOR THE ACTIONS, CONTENT, INFORMATION, OR DATA OF THIRD PARTIES, AND YOU RELEASE US, OUR DIRECTORS, OFFICERS, EMPLOYEES, AND AGENTS FROM ANY CLAIMS AND DAMAGES, KNOWN AND UNKNOWN, ARISING OUT OF OR IN ANY WAY CONNECTED WITH ANY CLAIM YOU HAVE AGAINST ANY SUCH THIRD PARTIES.\n      ")]),_vm._v(" "),_c('h3',[_vm._v(" Indemnification ")]),_vm._v(" "),_c('p',[_vm._v("\n         You (and also any third party for whom you operate an account or activity on the Service) agree to defend (at Company's request), indemnify and hold the Company Parties harmless from and against any claims, liabilities, damages, losses, and expenses, including without limitation, reasonable attorney's fees and costs, arising out of or in any way connected with any of the following (including as a result of your direct activities on the Service or those conducted on your behalf): (i) your Content or your access to or use of the Service; (ii) your breach or alleged breach of these Terms of Use; (iii) your violation of any third-party right, including without limitation, any intellectual property right, publicity, confidentiality, property or privacy right; (iv) your violation of any laws, rules, regulations, codes, statutes, ordinances or orders of any governmental and quasi-governmental authorities, including, without limitation, all regulatory, administrative and legislative authorities; or (v) any misrepresentation made by you. You will cooperate as fully required by Company in the defense of any claim. Company reserves the right to assume the exclusive defense and control of any matter subject to indemnification by you, and you will not in any event settle any claim without the prior written consent of Company.\n      ")]),_vm._v(" "),_c('h3',[_vm._v(" Governing Law & Venue ")]),_vm._v(" "),_c('p',[_vm._v("\n         Except as otherwise set out herein, this Agreement shall in all respects be governed by and interpreted, construed and enforced in accordance with the laws of the Province of Ontario and the laws of Canada applicable therein as applied to agreements entered into and to be performed entirely within Ontario, without regard to its choice of law or conflicts of law principles that would require application of law of a different jurisdiction. This agreement and any actions whatsoever taken by you in connection herewith and with any Service, software, tool, application or functionality, will be deemed to have been performed in Ontario, Canada. The parties hereto irrevocably submit and attorn to the exclusive jurisdiction and venue of the courts of the Province of Ontario, Canada.\n      ")]),_vm._v(" "),_c('p',[_vm._v("\n         If any provision of these Terms of Use is held to be unlawful, void, or for any reason unenforceable during arbitration or by a court of competent jurisdiction, then that provision will be deemed severable from these Terms of Use and will not affect the validity and enforceability of any remaining provisions. Company's failure to insist upon or enforce strict performance of any provision of these Terms will not be construed as a waiver of any provision or right. No waiver of any of these Terms will be deemed a further or continuing waiver of such term or condition or any other term or condition. Company reserves the right to change this dispute resolution provision, but any such changes will not apply to disputes arising before the effective date of the amendment. This dispute resolution provision will \n         survive the termination of any or all of your transactions with Company.\n      ")]),_vm._v(" "),_c('h3',[_vm._v(" Entire Agreement ")]),_vm._v(" "),_c('p',[_vm._v("\n         If you are using the Service on behalf of a legal entity, you represent that you are authorized to enter into an agreement on behalf of that legal entity. These Terms of Use constitute the entire agreement between you and Company and governs your use of the Service, superseding any prior agreements between you and Company. You will not assign the Terms of Use or assign any rights or delegate any obligations hereunder, in whole or in part, whether voluntarily or by operation of law, without the prior written consent of Company. Any purported assignment or delegation by you without the appropriate prior written consent of Company will be null and void. Company may assign these Terms of Use or any rights hereunder without your consent. If any provision of these Terms of Use is found by a court of competent jurisdiction to be invalid or otherwise unenforceable, the parties nevertheless agree that such portion will be deemed severable from these Terms of Use and will not affect the validity and enforceability of the remaining provisions, and the remaining provisions of the Terms of Use remain in full force and effect. Neither the course of conduct between the parties nor trade practice will act to modify the Terms of Use. These Terms of Use do not confer any third-party beneficiary rights.\n      ")]),_vm._v(" "),_c('h3',[_vm._v(" Territorial Restrictions ")]),_vm._v(" "),_c('p',[_vm._v("\n         The information provided within the Service is not intended for distribution to or use by any person or entity in any jurisdiction or country where such distribution or use would be contrary to law or regulation or which would subject Company to any registration requirement within such jurisdiction or country. We reserve the right to limit the availability of the Service or any portion of the Service, to any person, geographic area, or jurisdiction, at any time and in our sole discretion, and to limit the quantities of any content, program, product, service or other feature that Company provides. \n      ")]),_vm._v(" "),_c('p',[_vm._v("\n         Software related to or made available by the Service may be subject to United States export controls. Thus, no software from the Service may be downloaded, exported or re-exported: (a) into (or to a national or resident of) any country to which the United States has embargoed goods; or (b) to anyone on the U.S. Treasury Department's list of Specially Designated Nationals or the U.S. Commerce Department's Table of Deny Orders. By downloading any software related to the Service, you represent and warrant that you are not located in, under the control of, or a national or resident of, any such country or on any such list.\n      ")]),_vm._v(" "),_c('p',[_vm._v("\n         These Terms of Use were written in English (Canada). To the extent any translated version of these Terms of Use conflicts with the English version, the English version controls.\n      ")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "8/9o":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"schedule-demo"},[_c('a',{staticClass:"schedule-demo-button",on:{"click":_vm.showScheduleDemoPopup,"mousedown":function($event){$event.preventDefault();return _vm.preventMouseDown.apply(null, arguments)}}},[_vm._v(" Subscribe! ")]),_vm._v(" "),_c('transition',{attrs:{"name":"slide-fade"}},[(_vm.isDemoPopupVisible)?_c('div',{attrs:{"id":"container"}},[_c('div',{ref:"popupEl",attrs:{"id":"popup"}},[_c('img',{staticClass:"close-icon pointer",attrs:{"src":__webpack_require__("PpBQ")},on:{"click":_vm.hideScheduleDemoPopup}}),_vm._v(" "),_c('h2',[_vm._v("\n               Let's get started 🎈\n            ")]),_vm._v(" "),_c('div',{staticClass:"grey-out"},[_vm._v("\n               We secretly love coments too.\n            ")]),_vm._v(" "),_c('div',{staticClass:"fields-list",class:{ 'hide': _vm.submissionSuccess}},[_c('input',{directives:[{name:"model",rawName:"v-model.trim",value:(_vm.username),expression:"username",modifiers:{"trim":true}}],staticClass:"form-field",class:{ 'form-field-error': _vm.isFieldInvalid('username') },attrs:{"placeholder":"Username"},domProps:{"value":(_vm.username)},on:{"input":[function($event){if($event.target.composing){ return; }_vm.username=$event.target.value.trim()},function($event){return _vm.$v.username.$touch()}],"blur":function($event){return _vm.$forceUpdate()}}}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model.trim",value:(_vm.email),expression:"email",modifiers:{"trim":true}}],staticClass:"form-field",class:{ 'form-field-error': _vm.isFieldInvalid('email') },attrs:{"placeholder":"Email*"},domProps:{"value":(_vm.email)},on:{"input":[function($event){if($event.target.composing){ return; }_vm.email=$event.target.value.trim()},function($event){return _vm.$v.email.$touch()}],"blur":function($event){return _vm.$forceUpdate()}}})]),_vm._v(" "),_c('div',{staticClass:"success-icon-refpoint",class:{ 'hide': !_vm.submissionSuccess }},[_c('transition',{attrs:{"name":"slide-fade"}},[(_vm.submitted)?_c('img',{staticClass:"success-icon",attrs:{"src":__webpack_require__("fvQx")}}):_vm._e()])],1),_vm._v(" "),_c('div',{staticClass:"submit-row"},[(_vm.submissionState('button'))?_c('a',{staticClass:"submit-button",attrs:{"tabIndex":"0","disabled":_vm.isFormInvalid()},on:{"click":_vm.submitForm,"mousedown":function($event){$event.preventDefault();return _vm.preventMouseDown.apply(null, arguments)}}},[_vm._v("\n                  Submit\n               ")]):_vm._e(),_vm._v(" "),(_vm.submissionState('spinner'))?_c('rtx-spinner'):_vm._e(),_vm._v(" "),(_vm.submissionState('response'))?_c('div',[_vm._v(" "+_vm._s(_vm.response)+" "),(!_vm.submissionSuccess)?_c('a',{staticClass:"resubmit",on:{"click":_vm.submitForm}},[_vm._v(" Resubmit ")]):_vm._e()]):_vm._e()],1)])]):_vm._e()])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "8tZR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"comment"},[_c('div',{staticClass:"message"},[_c('span',{staticClass:"bigquotes quotes-left"},[_vm._v(" “  ")]),_vm._v(" "),_c('span',{staticClass:"text",domProps:{"innerHTML":_vm._s(_vm.comment.content.textDisplay)}}),_vm._v(" "),_c('span',{staticClass:"bigquotes quotes-right"},[_vm._v("  ” ")])]),_vm._v(" "),_c('div',{staticClass:"meta"},[_c('div',{staticClass:"author",attrs:{"title":_vm.comment.content.authorDisplayName}},[_vm._v("\n         "+_vm._s(_vm.comment.content.authorDisplayName)+"\n      ")]),_vm._v(" "),_c('div',{staticClass:"likes"},[_c('span',{staticClass:"likes-icon"},[_vm._v("▲ ")]),_vm._v("\n         "+_vm._s(_vm.likesCount)+"\n      ")]),_vm._v(" "),_c('timeago',{attrs:{"datetime":_vm.timestamp,"auto-update":60}})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "9KDB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[(!_vm.type || _vm.type === 'candy')?_c('span',{class:_vm.candyClass,on:{"click":function($event){return _vm.clicked(_vm.id)},"mousedown":function($event){$event.preventDefault();return _vm.preventMouseDown.apply(null, arguments)}}},[_vm._v(" \n      "+_vm._s(_vm.label)+" \n   ")]):_vm._e(),_vm._v(" "),(_vm.type === 'page')?_c('span',{class:_vm.pageClass,on:{"click":function($event){return _vm.clicked(_vm.id)},"mousedown":function($event){$event.preventDefault();return _vm.preventMouseDown.apply(null, arguments)}}},[_vm._v(" \n      "+_vm._s(_vm.label)+"\n   ")]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "9iUS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Footer_vue__ = __webpack_require__("B2UH");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0bfe7012_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Footer_vue__ = __webpack_require__("t7h/");
function injectStyle (ssrContext) {
  __webpack_require__("BGEQ")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-0bfe7012"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Footer_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0bfe7012_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Footer_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "AJCk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TabButton_vue__ = __webpack_require__("eB1I");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1426c0be_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TabButton_vue__ = __webpack_require__("9KDB");
function injectStyle (ssrContext) {
  __webpack_require__("S0bj")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-1426c0be"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TabButton_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1426c0be_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TabButton_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "B2UH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
   name: 'Footer',
   data: function data() {
      return {
         copyrightYear: new Date().getFullYear()
      };
   },

   methods: {
      preventMouseDown: function preventMouseDown(e) {}
   }
});

/***/ }),

/***/ "BGEQ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "CHNn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__ = __webpack_require__("+cKO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__backend_site_js__ = __webpack_require__("n2d5");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




// Initial data object
function initialData() {
   return {
      username: '',
      email: '',
      submitted: false,
      response: '',
      popupVisible: false,
      submissionSuccess: false,
      popupOpenedAtScreenWidth: 0,
      popupOpenedAtScreenHeight: 0
   };
}

/* harmony default export */ __webpack_exports__["a"] = ({
   name: 'ScheduleDemo',
   data: initialData,
   computed: {
      isDemoPopupVisible: function isDemoPopupVisible() {
         return this.popupVisible;
      }
   },
   methods: {
      preventMouseDown: function preventMouseDown(e) {},
      showScheduleDemoPopup: function showScheduleDemoPopup() {
         this.popupOpenedAtScreenWidth = window.innerWidth;
         this.popupOpenedAtScreenHeight = window.innerHeight;
         this.popupVisible = true;
         this.scrollToDemoElement();
      },
      hideScheduleDemoPopup: function hideScheduleDemoPopup() {
         __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(this.$data, initialData());
         this.$v.$reset(); // Reset validation
      },
      submitForm: function submitForm() {
         var _this = this;

         if (!this.isFormInvalid()) {
            var formData = this._.pick(this.$data, ['username', 'email']);
            this.submitted = true;

            Object(__WEBPACK_IMPORTED_MODULE_2__backend_site_js__["d" /* requestDemo */])(formData).then(function (result) {
               var data = result.data;
               if (data.status === 'success') {
                  _this.submissionSuccess = true;
                  _this.response = data.message;
               } else {
                  _this.response = data.message;
               }
            }).catch(function (error) {
               _this.response = 'Failed to submit request.';
            });
         }
      },
      isFieldInvalid: function isFieldInvalid(fieldName) {
         return this.$v[fieldName].$invalid && this.$v[fieldName].$dirty;
      },
      isFormInvalid: function isFormInvalid() {
         return this.$v.$invalid;
      },
      submissionState: function submissionState(viewItem) {
         if (viewItem === 'button') {
            if (!this.submitted) return true;
         };
         if (viewItem === 'spinner') {
            if (this.submitted && !this.response) return true;
         };
         if (viewItem === 'response') {
            if (this.submitted && this.response) return true;
         };
      },
      scrollToDemoElement: function scrollToDemoElement() {
         // The hidden element won't be available right away, try next tick
         this.$nextTick(function () {
            if (window.innerHeight <= 520) {
               this.$scrollTo(this.$refs.popupEl);
            } else {
               if (window.innerWidth <= 680) {
                  // Same as responsive UI max-width
                  this.$scrollTo(this.$el);
               }
            }
         });
      },
      scrollToDemoOnResize: function scrollToDemoOnResize() {
         if (this.isDemoPopupVisible) {
            if (window.innerHeight <= 520) {
               this.$refs.popupEl.scrollIntoView();
            } else {
               if (window.innerWidth <= 680) {
                  // Same as responsive UI max-width
                  this.$el.scrollIntoView();
               }
            }
         }
      }
   },
   created: function created() {
      window.addEventListener('resize', this.scrollToDemoOnResize);
   },
   destroyed: function destroyed() {
      window.removeEventListener('resize', this.scrollToDemoOnResize);
   },
   validations: {
      username: { minLength: Object(__WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__["minLength"])(2), maxLength: Object(__WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__["maxLength"])(64) },
      email: { required: __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__["required"], email: __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__["email"], maxLength: Object(__WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__["maxLength"])(256) }
   }
});

/***/ }),

/***/ "D1Mp":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "FSh0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"page"}},[_c('site-header',{attrs:{"title":"Privacy Policy"}}),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('site-footer')],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content-row"},[_c('h4',[_vm._v("\n         Privacy Policy\n         "),_c('br'),_vm._v("Effective date: May 3rd, 2020\n      ")]),_vm._v(" "),_c('p',[_vm._v("\n         Your privacy is critically important to us.\n      ")]),_vm._v(" "),_c('p',[_vm._v("\n         It is Company Inc.'s policy to respect your privacy regarding any informaion we may collect while operating our websites. This Privacy Policy applies to "),_c('a',{attrs:{"href":"https://www.commentoid.com"}},[_vm._v(" www.commentoid.com ")]),_vm._v(" (hereinafter, \"Company,\" \"us\", \"we\", \"Commentoid\" or \"www.commentoid.com\"). We respect your privacy and are committed to protecting personally identifiable information you may provide us through the Website. We have adopted this privacy policy (\"Privacy Policy\") to explain what information may be collected on our Website and through our services, how we use this information, and under what circumstances we may disclose the information to third parties.\n      ")]),_vm._v(" "),_c('p',[_vm._v("\n         Like most website operators, Company collects non-personally-identifying information of the sort that web browsers and servers typically make available, such as the browser type, language preference, referring site, and the date and time of each visitor request. Company's purpose in collecting non-personally identifying information is to better understand how Company visitors use its websites and services. From time to time, Company may release non-personally-identifying information in the aggregate, e.g., by publishing a report on trends in the usage of its websites.\n      ")]),_vm._v(" "),_c('p',[_vm._v("\n         Company also collects potentially personally-identifying information like Internet Protocol (IP) addresses for visiting and logged in users that interact with our websites and services. Company only discloses logged in user and commenter IP addresses under the same circumstances that it uses and discloses personally-identifying information as described below:\n      ")]),_vm._v(" "),_c('h3',[_vm._v(" Gathering of Personally-Identifying Information ")]),_vm._v(" "),_c('p',[_vm._v("\n         Certain visitors to Company's websites choose to interact with Company in ways that require Company to gather personally-identifying information. The amount and type of information that Company gathers depends on the nature of the interaction. For example, we ask visitors who sign up for a customer account at https://www.commentoid.com to provide their full name, phone number, email address and company name.\n      ")]),_vm._v(" "),_c('p',[_vm._v("\n         The security of your Personal Information is important to us, but remember that no method of transmission over the Internet, or method of electronic storage is 100% secure. While we strive to use commercially acceptable means to protect your Personal Information, we cannot guarantee its absolute security.\n      ")]),_vm._v(" "),_c('h3',[_vm._v(" Links To External Sites ")]),_vm._v(" "),_c('p',[_vm._v("\n         Our Service may contain links to external sites that are not operated by us. If you click on a third party link, you will be directed to that third party's site. We strongly advise you to review the Privacy Policy and terms and conditions of every site you visit.\n      ")]),_vm._v(" "),_c('p',[_vm._v("\n         We have no control over, and assume no responsibility for the content, privacy policies or practices of any third party sites, products or services.\n      ")]),_vm._v(" "),_c('h3',[_vm._v(" Protection of Certain Personally-Identifying Information ")]),_vm._v(" "),_c('p',[_vm._v("\n         Company discloses potentially personally-identifying and personally-identifying information only to those of its employees, contractors and affiliated organizations that (i) need to know that information in order to process it on Company's behalf or to provide services available on the Company's websites, and (ii) that have agreed not to disclose it to others. Some of those employees, contractors and affiliated organizations may be located outside of your home country; by using Company's websites, you consent to the transfer of such information to them. Company will not rent or sell potentially personally-identifying and personally-identifying information to anyone. Other than to its employees, contractors and affiliated organizations, as described above, Company discloses potentially personally-identifying and personally-identifying information only in response to a subpoena, court order or other governmental request, or when Company believes in good faith that disclosure is reasonably necessary to protect the property or rights of Company, third parties or the public at large.\n      ")]),_vm._v(" "),_c('p',[_vm._v("\n         If you are a registered user of https://www.commentoid.com and have supplied your email address, Company may occasionally send you an email to tell you about new features, solicit your feedback, or just keep you up to date with what’s going on with Company and our products. If you send us a request (for example via a support email or via one of our feedback mechanisms), we reserve the right to publish it in order to help us clarify or respond to your request or to help us support other users. Company takes all measures reasonably necessary to protect against the unauthorized access, use, alteration or destruction of potentially personally-identifying and personally-identifying information.")]),_vm._v(" "),_c('p'),_vm._v(" "),_c('h3',[_vm._v(" Aggregated Statistics ")]),_vm._v(" "),_c('p',[_vm._v("\n         Company may collect statistics about the behavior of visitors to its websites. Company may display this information publicly or provide it to others. However, Company does not disclose your personally-identifying information.\n      ")]),_vm._v(" "),_c('h3',[_vm._v(" Cookies ")]),_vm._v(" "),_c('p',[_vm._v("\n         To enrich and perfect your online experience, Company uses \"Cookies\", similar technologies and services provided by others to display personalized content, appropriate advertising and store your preferences on your computer.\n      ")]),_vm._v(" "),_c('p',[_vm._v("\n         A cookie is a string of information that a website stores on a visitor’s computer, and that the visitor’s browser provides to the website each time the visitor returns. Company uses cookies to help Company identify and track visitors, their usage of https://www.commentoid.com, and their website access preferences. Commentoid visitors who do not wish to have cookies placed on their computers should set their browsers to refuse cookies before using Company's websites, with the drawback that certain features of Company’s websites may not function properly without the aid of cookies.\n      ")]),_vm._v(" "),_c('p',[_vm._v("\n         We may use cookies form third-party partners such as Google and Facebook for marketing purposes. These cookies allow us to display promotional material to you on other sites you visit across the Internet. Company may also share information about your behavior on our services with third parties in order to show you targeted advertisements and other content that has been customized for you.\n      ")]),_c('p',[_vm._v("\n         By continuing to navigate our website without changing your cookie settings, you hereby acknowledge and agree to Company's use of cookies.\n      ")]),_vm._v(" "),_c('h3',[_vm._v(" Privacy Policy Changes ")]),_vm._v(" "),_c('p',[_vm._v("\n         Although most changes are likely to be minor, Company may change its Privacy Policy from time to time, and in Company's sole discretion. Company encourages visitors to frequently check this page for any changes to its Privacy Policy. Your continued use of this site after any change in this Privacy Policy will constitute your acceptance of such change.\n      ")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "FTR0":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "GMA7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var AppLib = __webpack_require__("dTEU");

/* harmony default export */ __webpack_exports__["a"] = ({
   name: "Comment",
   props: ["comment"],
   computed: {
      timestamp: function timestamp() {
         return this.comment.content.publishedAt;
      },
      likesCount: function likesCount() {
         var statArray = this.comment.stats || [];
         var lastStat = statArray[statArray.length - 1] || {};
         var likes = lastStat.likes || 0;
         return AppLib.scaleFormatNumber(likes, 1);
      }
   }
});

/***/ }),

/***/ "GgDs":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Header_vue__ = __webpack_require__("JBW2");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_402abd6b_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Header_vue__ = __webpack_require__("fQ1k");
function injectStyle (ssrContext) {
  __webpack_require__("WFZI")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-402abd6b"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Header_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_402abd6b_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Header_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "HMNQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Comment_vue__ = __webpack_require__("LbPb");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


var AppLib = __webpack_require__("dTEU");

/* harmony default export */ __webpack_exports__["a"] = ({
   name: "Entry",
   components: {
      Comment: __WEBPACK_IMPORTED_MODULE_1__Comment_vue__["a" /* default */]
   },
   props: {
      entry: {
         type: Object,
         required: true
      },
      // Modes: "tileOneLine", "tile" (or "tileTwoLines") or "single"
      // "single" shows the full entry (no hover/click effect)
      tileType: {
         type: String,
         default: "tile"
      },
      // Number of comments to show (ignored in single mode)
      maxComments: {
         type: Number,
         default: 1
      }
   },
   data: function data() {
      return {
         fullCommentsLoaded: false
      };
   },

   computed: {
      // Use fewer characters on mobile, more on desktop
      commentTruncateLength: function commentTruncateLength() {
         return window.innerWidth < 768 ? 128 : 300;
      },
      displayedComments: function displayedComments() {
         var _this = this;

         var all = (this.entry.comments || []).map(function (c) {
            return _this.truncatedComment(c);
         });
         if (this.tileType === "single") {
            return all;
         }
         return all.slice(0, this.maxComments);
      },
      shouldShowComments: function shouldShowComments() {
         if (this.tileType === "single") {
            return this.displayedComments.length > 0;
         }
         return this.maxComments > 0 && this.displayedComments.length > 0;
      },
      likesCount: function likesCount() {
         var statsArray = this.entry.entry.stats || [];
         var lastStat = statsArray[statsArray.length - 1] || {};
         var views = lastStat.views || 0;
         return AppLib.scaleFormatNumber(views, 1);
      },
      titleClampClass: function titleClampClass() {
         if (this.tileType === "tileOneLine") {
            return "clamp-one-line";
         } else if (this.tileType === "single") {
            return "";
         } else {
            return "clamp-two-lines";
         }
      },
      commentsMinHeight: function commentsMinHeight() {
         if (this.tileType === "single") {
            return "auto";
         }
         var linesPerComment = 4;
         var lineHeightEm = 1.2;
         var extraOffset = 1.5;
         var totalLines = this.maxComments * linesPerComment;
         return totalLines * lineHeightEm + extraOffset + "em";
      },
      headingImageStyle: function headingImageStyle() {
         return {
            backgroundImage: "url(" + this.bestThumbUrl + ")",
            backgroundSize: "cover",
            backgroundPosition: "center",
            height: "10rem",
            width: "100%",
            opacity: "0.9"
         };
      },
      bestThumbUrl: function bestThumbUrl() {
         var thumbs = this.entry.entry.thumbnails || {};
         if (thumbs.maxres && thumbs.maxres.url) {
            return thumbs.maxres.url;
         }
         if (thumbs.high && thumbs.high.url) {
            return thumbs.high.url;
         }
         return "https://via.placeholder.com/400x200?text=No+Image";
      },
      showExtraStats: function showExtraStats() {
         return this.maxComments === 0 && this.tileType !== "single";
      },
      extraStatsText: function extraStatsText() {
         var commentCount = this.entry.comments ? this.entry.comments.length : 0;
         return "Comments: " + commentCount + ", Likes: " + this.likesCount;
      }
   },
   methods: {
      handleClick: function handleClick() {
         // Only allow click-to-navigate if not in single mode
         if (this.tileType !== "single") {
            this.goToEntry();
         }
      },
      goToEntry: function goToEntry() {
         window.location.href = this.entryUrl();
      },
      composeSourceURL: function composeSourceURL() {
         return "https://www.youtube.com/watch?v=" + this.entry.entryId;
      },
      entryUrl: function entryUrl() {
         return "/e/" + this.entry.entry.urlId;
      },
      truncatedComment: function truncatedComment(original) {
         var copy = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(original));
         if (copy.content && copy.content.textDisplay && copy.content.textDisplay.length > this.commentTruncateLength) {
            copy.content.textDisplay = copy.content.textDisplay.slice(0, this.commentTruncateLength) + "...";
         }
         return copy;
      },
      getFullEntry: function getFullEntry() {
         var _this2 = this;

         if (this.fullCommentsLoaded) return;
         // Simulate API call to load full comments
         setTimeout(function () {
            if (!_this2.entry.comments) {
               _this2.$set(_this2.entry, "comments", []);
            }
            _this2.entry.comments.push({
               content: {
                  textDisplay: "Additional comment loaded from backend.",
                  authorDisplayName: "BackendUser",
                  publishedAt: "2023-01-03"
               },
               stats: [{ likes: 3 }]
            });
            _this2.fullCommentsLoaded = true;
         }, 500);
      }
   },
   mounted: function mounted() {
      if (this.tileType === "single") {
         this.getFullEntry();
      }
   }
});

/***/ }),

/***/ "HSuB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Entry_vue__ = __webpack_require__("HMNQ");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_56ae21f0_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Entry_vue__ = __webpack_require__("rxWM");
function injectStyle (ssrContext) {
  __webpack_require__("WNeM")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-56ae21f0"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Entry_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_56ae21f0_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Entry_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "IcnI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("/5sW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");



__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */]);

var debug = "production" !== 'production';

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */].Store({
   state: {
      ui: {
         userMenuVisible: false,
         contactFormVisible: false
      },
      DEBUG: true
   },
   getters: {},
   mutations: {
      // User menu mutations (app wide)
      toggleUserMenu: function toggleUserMenu(state) {
         state.ui.userMenuVisible = !state.ui.userMenuVisible;
      },
      hideUserMenu: function hideUserMenu(state) {
         state.ui.userMenuVisible = false;
      },
      // Contact Form
      showContactForm: function showContactForm(state) {
         state.ui.contactFormVisible = true;
      },
      hideContactForm: function hideContactForm(state) {
         state.ui.contactFormVisible = false;
      }
   },
   strict: debug
}));

/***/ }),

/***/ "J5fL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Landing_vue__ = __webpack_require__("lGUq");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3d0d0d0f_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Landing_vue__ = __webpack_require__("dxWu");
function injectStyle (ssrContext) {
  __webpack_require__("eh1t")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-3d0d0d0f"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Landing_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3d0d0d0f_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Landing_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "JBW2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
   name: 'Landing',
   props: ['title'],
   data: function data() {
      return {};
   },

   methods: {
      preventMouseDown: function preventMouseDown(e) {},
      navigateToHome: function navigateToHome(ev) {
         window.location = '/';
      }
   }
});

/***/ }),

/***/ "LMa+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bar"},_vm._l((_vm.tabs),function(tab){return _c('div',{staticClass:"button-container"},[_c('tab-button',{attrs:{"active":tab.id === _vm.activeItemId,"label":tab.label,"id":tab.id,"type":_vm.type},on:{"clicked":_vm.clicked}})],1)}),0)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "LbPb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Comment_vue__ = __webpack_require__("GMA7");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7e1f45e1_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Comment_vue__ = __webpack_require__("8tZR");
function injectStyle (ssrContext) {
  __webpack_require__("FTR0")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-7e1f45e1"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Comment_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7e1f45e1_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Comment_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("/5sW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Commentoid__ = __webpack_require__("OjGc");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__("YaEn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store_index__ = __webpack_require__("IcnI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue2_filters__ = __webpack_require__("OjAt");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue2_filters___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue2_filters__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_lodash__ = __webpack_require__("0O0x");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_router__ = __webpack_require__("/ocq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vuelidate__ = __webpack_require__("ESwS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vuelidate___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vuelidate__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_timeago__ = __webpack_require__("J/A3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue_meta__ = __webpack_require__("f3bp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_common_form_TabBar__ = __webpack_require__("oNiF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_common_form_TabButton__ = __webpack_require__("AJCk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_common_RTXSpinner_vue__ = __webpack_require__("n7OB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_common_Header_vue__ = __webpack_require__("GgDs");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_common_Footer__ = __webpack_require__("9iUS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_site_ScheduleDemo__ = __webpack_require__("eiY/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_site_Entry__ = __webpack_require__("HSuB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_site_Comment__ = __webpack_require__("LbPb");











var VueScrollTo = __webpack_require__("bm7V");
var VueCookie = __webpack_require__("K/Lq");

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;

// Vue plugins
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_4_vue2_filters___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_5_vue_lodash___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_6_vue_router__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_7_vuelidate___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(VueCookie);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(VueScrollTo, {
   container: "#landing",
   duration: 1200,
   easing: "ease",
   offset: 0,
   force: true,
   cancelable: true,
   onStart: false,
   onDone: false,
   onCancel: false,
   x: false,
   y: true
});
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_8_vue_timeago__["a" /* default */], {
   name: 'Timeago',
   locale: 'en'
});
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_9_vue_meta__["a" /* default */], {
   refreshOnceOnNavigation: true
});

// * Load Components *
// -- Common

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('tab-bar', __WEBPACK_IMPORTED_MODULE_10__components_common_form_TabBar__["a" /* default */]);


__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('tab-button', __WEBPACK_IMPORTED_MODULE_11__components_common_form_TabButton__["a" /* default */]);


__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('rtx-spinner', __WEBPACK_IMPORTED_MODULE_12__components_common_RTXSpinner_vue__["a" /* default */]);


__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('site-header', __WEBPACK_IMPORTED_MODULE_13__components_common_Header_vue__["a" /* default */]);


__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('site-footer', __WEBPACK_IMPORTED_MODULE_14__components_common_Footer__["a" /* default */]);

// -- Site

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('schedule-demo', __WEBPACK_IMPORTED_MODULE_15__components_site_ScheduleDemo__["a" /* default */]);


__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('ctd-entry', __WEBPACK_IMPORTED_MODULE_16__components_site_Entry__["a" /* default */]);


__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('ctd-comment', __WEBPACK_IMPORTED_MODULE_17__components_site_Comment__["a" /* default */]);

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
   el: '#app',
   router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
   store: __WEBPACK_IMPORTED_MODULE_3__store_index__["a" /* default */],
   render: function render(h) {
      return h(__WEBPACK_IMPORTED_MODULE_1__Commentoid__["a" /* default */]);
   }
});

/***/ }),

/***/ "OjGc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Commentoid_vue__ = __webpack_require__("Y9Jr");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_71ae7783_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Commentoid_vue__ = __webpack_require__("uODH");
function injectStyle (ssrContext) {
  __webpack_require__("cT9I")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Commentoid_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_71ae7783_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Commentoid_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "PpBQ":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "S0bj":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "VRLR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Legal_vue__ = __webpack_require__("f8fG");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_68874eda_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Legal_vue__ = __webpack_require__("5QPK");
function injectStyle (ssrContext) {
  __webpack_require__("zP1w")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-68874eda"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Legal_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_68874eda_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Legal_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "WFZI":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "WNeM":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Y3lg":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/commentoid_text_logo.1e390be.png";

/***/ }),

/***/ "Y9Jr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
   name: 'app',
   data: function data() {
      return {
         msg: 'Commentoid.'
      };
   }
});

/***/ }),

/***/ "YaEn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("/5sW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__("/ocq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_site_Landing__ = __webpack_require__("J5fL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_site_Legal__ = __webpack_require__("VRLR");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_site_Privacy__ = __webpack_require__("lWrC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_common_NotFound__ = __webpack_require__("1Dap");







__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
   routes: [{
      path: '/',
      name: 'Landing',
      component: __WEBPACK_IMPORTED_MODULE_2__components_site_Landing__["a" /* default */]
   }, {
      path: '/e/:eid',
      name: 'Entry',
      component: __WEBPACK_IMPORTED_MODULE_2__components_site_Landing__["a" /* default */]
   }, {
      path: '/t/:topic',
      name: 'Topic',
      component: __WEBPACK_IMPORTED_MODULE_2__components_site_Landing__["a" /* default */]
   }, {
      path: '/legal',
      name: 'Legal',
      component: __WEBPACK_IMPORTED_MODULE_3__components_site_Legal__["a" /* default */]
   }, {
      path: '/privacy',
      name: 'Privacy',
      component: __WEBPACK_IMPORTED_MODULE_4__components_site_Privacy__["a" /* default */]
   }, {
      path: '*',
      name: 'NotFound',
      component: __WEBPACK_IMPORTED_MODULE_5__components_common_NotFound__["a" /* default */]
   }],
   mode: 'history'
}));

/***/ }),

/***/ "b/xm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"looping-rhombuses-spinner"},[_c('div',{staticClass:"rhombus"}),_vm._v(" "),_c('div',{staticClass:"rhombus"}),_vm._v(" "),_c('div',{staticClass:"rhombus"})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "cT9I":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "d1sA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"page"}},[_c('site-header'),_vm._v(" "),_vm._m(0)],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content-row"},[_c('h1',[_vm._v(" Resource Not Found ")]),_vm._v(" "),_c('p',[_vm._v(" Please verify the URL path and try again. ")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "dTEU":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


const RADIX = 10;

// Commentoid Utiltis Library
const AppLib = {
   scaleFormatNumber: function scaleFormatNumber (message, decimals) {
      var value = message;
      var isValueNegative = (value < 0);
      (decimals > 2) ? decimals = 2 : decimals;
      (value < 0) ? value = Math.abs(value): value;
      var valueScaledString = '';
      var scaleBuckets = ['', 'K', 'M', 'B', 'T', 'P', 'E', 'Z', 'Y'];
      if (value > -1000 && value < 1000) {
         var val = Math.round(value);
         return val.toString(RADIX);
      } else {
         var valueRoundedLength = Math.round(value).toString(RADIX).length;
         var valueBase10Magnitude = parseInt((valueRoundedLength - 1)/3, 10);
         var scaleTo = Math.pow(10, valueBase10Magnitude * 3);
         var fixedDecimals = (value/scaleTo).toFixed(decimals);
         // Handle toFixed rounding up to "1000" unit
         var fixedLeftValue = parseInt(fixedDecimals, 10);
         if (fixedLeftValue === 1000) {
            valueBase10Magnitude = valueBase10Magnitude + 1; 
            fixedDecimals = "1.0";
         }
         valueScaledString = fixedDecimals + scaleBuckets[valueBase10Magnitude];
         return (!isValueNegative) ? valueScaledString : '-' + valueScaledString;
      }
   }
}

module.exports = AppLib;

/***/ }),

/***/ "dxWu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"landing"}},[(_vm.feed.length < 1)?_c('rtx-spinner',{staticClass:"page-spinner"}):_c('div',[_c('site-header'),_vm._v(" "),(_vm.isSingleEntry)?_c('div',[_c('entry',{attrs:{"entry":_vm.feed[0],"tileType":"single"}})],1):_c('div',[_c('tiles',{attrs:{"feed":_vm.feed}})],1),_vm._v(" "),_c('site-footer',{ref:"footerElement"})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "eB1I":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// Should probably convert this component to use scoped-slots in the future
/* harmony default export */ __webpack_exports__["a"] = ({
   name: 'ActionButton',
   props: {
      label: {
         type: String,
         required: true
      },
      id: {
         type: String,
         required: true
      },
      active: {
         type: Boolean,
         required: true
      },
      type: {
         type: String,
         required: false
      }
   },
   data: function data() {
      return {};
   },
   methods: {
      clicked: function clicked(itemId) {
         this.$emit('clicked', itemId);
      },
      preventMouseDown: function preventMouseDown(e) {}
   },
   computed: {
      candyClass: function candyClass() {
         return {
            'candy-button': true,
            'candy-active': this.active,
            'candy-inactive': !this.active
         };
      },
      pageClass: function pageClass() {
         return {
            'page-button': true,
            'page-active': this.active,
            'page-inactive': !this.active
         };
      }
   }
});

/***/ }),

/***/ "eh1t":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "eiY/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ScheduleDemo_vue__ = __webpack_require__("CHNn");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_061a61eb_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ScheduleDemo_vue__ = __webpack_require__("8/9o");
function injectStyle (ssrContext) {
  __webpack_require__("xoEG")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-061a61eb"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ScheduleDemo_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_061a61eb_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ScheduleDemo_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "f8fG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
   data: function data() {
      return {
         msg: ''
      };
   },

   methods: {
      preventMouseDown: function preventMouseDown(e) {}
   }
});

/***/ }),

/***/ "fQ1k":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"header"},[_c('a',{attrs:{"href":"/"}},[_c('img',{staticClass:"logo-text",attrs:{"src":__webpack_require__("Y3lg"),"height":"42px"}})])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "fvQx":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4NCjwhLS0gR2VuZXJhdG9yOiBBZG9iZSBJbGx1c3RyYXRvciAxOC4xLjEsIFNWRyBFeHBvcnQgUGx1Zy1JbiAuIFNWRyBWZXJzaW9uOiA2LjAwIEJ1aWxkIDApICAtLT4NCjxzdmcgdmVyc2lvbj0iMS4xIiBpZD0iTGF5ZXJfMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayIgeD0iMHB4IiB5PSIwcHgiDQoJIHZpZXdCb3g9IjAgMCAxMDI0IDEwMjQiIGVuYWJsZS1iYWNrZ3JvdW5kPSJuZXcgMCAwIDEwMjQgMTAyNCIgeG1sOnNwYWNlPSJwcmVzZXJ2ZSI+DQo8Zz4NCgk8cGF0aCBmaWxsPSIjMDEwMTAxIiBkPSJNNTEyLDk1OS45QzI2NSw5NTkuOSw2NC4xLDc1OSw2NC4xLDUxMlMyNjUsNjQuMSw1MTIsNjQuMVM5NTkuOSwyNjUsOTU5LjksNTEyUzc1OSw5NTkuOSw1MTIsOTU5Ljl6DQoJCSBNNTEyLDg1LjhjLTU3LjYsMC0xMTMuNSwxMS4zLTE2NiwzMy41Yy01MC44LDIxLjQtOTYuNCw1Mi4yLTEzNS41LDkxLjNjLTM5LjEsMzkuMS02OS44LDg0LjctOTEuMywxMzUuNQ0KCQlDOTcsMzk4LjUsODUuOCw0NTQuNCw4NS44LDUxMlM5Nyw2MjUuNSwxMTkuMiw2NzhjMjEuNCw1MC44LDUyLjIsOTYuNCw5MS4zLDEzNS41YzM5LjEsMzkuMSw4NC43LDY5LjgsMTM1LjUsOTEuMw0KCQljNTIuNiwyMi4yLDEwOC40LDMzLjUsMTY2LDMzLjVzMTEzLjUtMTEuMywxNjYtMzMuNWM1MC44LTIxLjUsOTYuNC01Mi4yLDEzNS41LTkxLjNjMzkuMS0zOS4xLDY5LjgtODQuNyw5MS4zLTEzNS41DQoJCWMyMi4yLTUyLjYsMzMuNS0xMDguNCwzMy41LTE2NlM5MjcsMzk4LjUsOTA0LjgsMzQ2Yy0yMS41LTUwLjgtNTIuMi05Ni40LTkxLjMtMTM1LjVjLTM5LjEtMzkuMS04NC43LTY5LjgtMTM1LjUtOTEuMw0KCQlDNjI1LjUsOTcsNTY5LjYsODUuOCw1MTIsODUuOHogTTQ0OS42LDY1Ny45Yy0zLDAtNS43LTEuMi03LjgtMy4zTDMwOC45LDUxOC4xYy0yLTIuMS0zLTQuOS0zLTcuN2MwLjEtMi45LDEuMy01LjYsMy40LTcuNg0KCQljMi0xLjksNC43LTMsNy40LTNjMywwLDUuOCwxLjIsNy45LDMuNGwxMjUsMTI4LjRsMjc1LjktMjgzLjZjMi0yLjEsNC42LTMuMyw3LjQtMy40YzAuMSwwLDAuMywwLDAuNCwwYzIuOSwwLDUuNiwxLjEsNy42LDMuMQ0KCQljMi4xLDIsMy4yLDQuNywzLjIsNy42YzAsMi45LTEuMSw1LjYtMy4xLDcuN0w0NTcuNCw2NTQuNmMtMC4xLDAuMS0wLjIsMC4yLTAuMywwLjNDNDU1LjEsNjU2LjgsNDUyLjQsNjU3LjksNDQ5LjYsNjU3LjkNCgkJQzQ0OS42LDY1Ny45LDQ0OS42LDY1Ny45LDQ0OS42LDY1Ny45eiIvPg0KPC9nPg0KPC9zdmc+DQo="

/***/ }),

/***/ "iMhh":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "idgZ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "kdTb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//

function initialData() {
   return {};
}
/* harmony default export */ __webpack_exports__["a"] = ({
   data: initialData,
   methods: {
      preventMouseDown: function preventMouseDown(e) {}
   }
});

/***/ }),

/***/ "lGUq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__backend_site_js__ = __webpack_require__("n2d5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_site_Tiles_vue__ = __webpack_require__("/W6S");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_site_Entry_vue__ = __webpack_require__("HSuB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_common_Header_vue__ = __webpack_require__("GgDs");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_common_Footer_vue__ = __webpack_require__("9iUS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_common_RTXSpinner_vue__ = __webpack_require__("n7OB");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//










/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Landing',
  components: {
    tiles: __WEBPACK_IMPORTED_MODULE_1__components_site_Tiles_vue__["a" /* default */],
    entry: __WEBPACK_IMPORTED_MODULE_2__components_site_Entry_vue__["a" /* default */],
    SiteHeader: __WEBPACK_IMPORTED_MODULE_3__components_common_Header_vue__["a" /* default */],
    SiteFooter: __WEBPACK_IMPORTED_MODULE_4__components_common_Footer_vue__["a" /* default */],
    RTXSpinner: __WEBPACK_IMPORTED_MODULE_5__components_common_RTXSpinner_vue__["a" /* default */]
  },
  data: function data() {
    return {
      selectedPageId: 'pagashi',
      viewportSize: 0,
      feed: []
    };
  },

  computed: {
    isSingleEntry: function isSingleEntry() {
      return !!this.$route.params.eid;
    },
    currentEntry: function currentEntry() {
      return this.isSingleEntry ? this.feed[0] : null;
    },
    pageTitle: function pageTitle() {
      if (this.currentEntry) {
        var title = this.currentEntry.entry.content.title;
        return title + ' - Commentoid';
      } else {
        return 'Commentoid - Trending 🔥';
      }
    },
    pageUrl: function pageUrl() {
      return window.location.href;
    },
    pageDescription: function pageDescription() {
      if (this.currentEntry) {
        return this.currentEntry.entry.content.description;
      } else {
        return 'Explore popular and trending comments.';
      }
    },
    ogDescription: function ogDescription() {
      if (this.currentEntry) {
        return this.currentEntry.entry.content.description;
      } else {
        return 'Explore trending and popular comments on hot topics brewing on the web. Discover past favorites updated daily.';
      }
    },
    ogImage: function ogImage() {
      if (this.currentEntry) {
        return this.currentEntry.entry.thumbnails.high.url;
      } else {
        return 'https://www.commentoid.com/static/commentoid-og-image.png';
      }
    }
  },
  metaInfo: function metaInfo() {
    return {
      title: this.pageTitle,
      titleTemplate: '%s',
      meta: [{ name: 'title', content: this.pageTitle }, { name: 'description', content: this.pageDescription }, { property: 'og:type', content: 'website' }, { property: 'og:url', content: this.pageUrl }, { property: 'og:title', content: this.pageTitle }, { property: 'og:description', content: this.ogDescription }, { property: 'og:image', content: this.ogImage }, { property: 'twitter:card', content: 'summary_large_image' }, { property: 'twitter:url', content: this.pageUrl }, { property: 'twitter:title', content: this.pageTitle }, { property: 'twitter:description', content: this.ogDescription }, { property: 'twitter:image', content: this.ogImage }]
    };
  },
  mounted: function mounted() {
    this.updateViewportSize();
    window.addEventListener('resize', this.updateViewportSize);
    // Check route parameters: if "eid" is present, fetch that single entry;
    // if "topic" is provided, fetch topic entries; otherwise, get the trending feed.
    var urlId = this.$route.params.eid;
    var topic = this.$route.params.topic;
    if (urlId) {
      this.getEntry(urlId);
    } else if (topic) {
      this.getTopic(topic);
    } else {
      this.getFeed();
    }
  },
  created: function created() {
    window.addEventListener('resize', this.updateViewportSize);
  },
  destroyed: function destroyed() {
    window.removeEventListener('resize', this.updateViewportSize);
  },

  methods: {
    updateViewportSize: function updateViewportSize() {
      this.viewportSize = window.innerWidth;
    },
    pageClicked: function pageClicked(payload) {
      this.selectedPageId = payload.itemId;
    },
    getFeed: function getFeed() {
      var _this = this;

      Object(__WEBPACK_IMPORTED_MODULE_0__backend_site_js__["c" /* getTrendingFeed */])({}).then(function (result) {
        _this.feed = result.data.value;
      }).catch(function (error) {
        console.error('Failed to submit request.', error);
      });
    },
    getTopic: function getTopic(topic) {
      var _this2 = this;

      Object(__WEBPACK_IMPORTED_MODULE_0__backend_site_js__["b" /* getTopicEntries */])({ topic: topic }).then(function (result) {
        _this2.feed = result.data.value;
      }).catch(function (error) {
        console.error('Failed to submit request.', error);
      });
    },
    getEntry: function getEntry(urlId) {
      var _this3 = this;

      Object(__WEBPACK_IMPORTED_MODULE_0__backend_site_js__["a" /* getFullEntry */])({ urlId: urlId }).then(function (result) {
        _this3.feed = [result.data.value];
      }).catch(function (error) {
        console.error('Failed to submit request.', error);
      });
    }
  }
});

/***/ }),

/***/ "lWrC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Privacy_vue__ = __webpack_require__("oMLH");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_795bc13d_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Privacy_vue__ = __webpack_require__("FSh0");
function injectStyle (ssrContext) {
  __webpack_require__("zoSL")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-795bc13d"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Privacy_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_795bc13d_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Privacy_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "myor":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
   name: 'TabBar',
   props: {
      tabs: {
         type: Array,
         required: true
      },
      contextPath: {
         type: String,
         required: true
      },
      activeItemId: {
         type: String,
         required: false
      },
      type: {
         type: String,
         required: false
      }
   },
   data: function data() {
      return {};
   },
   computed: {},
   methods: {
      clicked: function clicked(itemId) {
         this.$emit('clicked', {
            itemId: itemId,
            contextPath: this.contextPath.toLowerCase()
         });
      }
   }
});

/***/ }),

/***/ "n2d5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return requestDemo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getTrendingFeed; });
/* unused harmony export getReplaysFeed */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getTopicEntries; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getFullEntry; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);


// Library Imports


// Set up axios defaults
__WEBPACK_IMPORTED_MODULE_2_axios___default.a.defaults.baseURL = 'https://www.commentoid.com';
__WEBPACK_IMPORTED_MODULE_2_axios___default.a.defaults.withCredentials = false;

var requestDemo = function () {
   var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(payload) {
      var f;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
         while (1) {
            switch (_context.prev = _context.next) {
               case 0:
                  _context.next = 2;
                  return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.post('/requestdemo', payload);

               case 2:
                  f = _context.sent;
                  return _context.abrupt('return', f);

               case 4:
               case 'end':
                  return _context.stop();
            }
         }
      }, _callee, this);
   }));

   return function requestDemo(_x) {
      return _ref.apply(this, arguments);
   };
}();

var getTrendingFeed = function () {
   var _ref2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(payload) {
      var f;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
         while (1) {
            switch (_context2.prev = _context2.next) {
               case 0:
                  _context2.next = 2;
                  return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get('/api/feed/trending', {
                     params: payload
                  });

               case 2:
                  f = _context2.sent;
                  return _context2.abrupt('return', f);

               case 4:
               case 'end':
                  return _context2.stop();
            }
         }
      }, _callee2, this);
   }));

   return function getTrendingFeed(_x2) {
      return _ref2.apply(this, arguments);
   };
}();

var getReplaysFeed = function () {
   var _ref3 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3(payload) {
      var f;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
         while (1) {
            switch (_context3.prev = _context3.next) {
               case 0:
                  _context3.next = 2;
                  return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get('/api/feed/replays', {
                     params: payload
                  });

               case 2:
                  f = _context3.sent;
                  return _context3.abrupt('return', f);

               case 4:
               case 'end':
                  return _context3.stop();
            }
         }
      }, _callee3, this);
   }));

   return function getReplaysFeed(_x3) {
      return _ref3.apply(this, arguments);
   };
}();

var getTopicEntries = function () {
   var _ref4 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4(payload) {
      var f;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
         while (1) {
            switch (_context4.prev = _context4.next) {
               case 0:
                  _context4.next = 2;
                  return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get('/api/topic', {
                     params: payload
                  });

               case 2:
                  f = _context4.sent;
                  return _context4.abrupt('return', f);

               case 4:
               case 'end':
                  return _context4.stop();
            }
         }
      }, _callee4, this);
   }));

   return function getTopicEntries(_x4) {
      return _ref4.apply(this, arguments);
   };
}();

var getFullEntry = function () {
   var _ref5 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee5(payload) {
      var f;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
         while (1) {
            switch (_context5.prev = _context5.next) {
               case 0:
                  _context5.next = 2;
                  return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get('/api/entry', {
                     params: payload
                  });

               case 2:
                  f = _context5.sent;
                  return _context5.abrupt('return', f);

               case 4:
               case 'end':
                  return _context5.stop();
            }
         }
      }, _callee5, this);
   }));

   return function getFullEntry(_x5) {
      return _ref5.apply(this, arguments);
   };
}();

/***/ }),

/***/ "n7OB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RTXSpinner_vue__ = __webpack_require__("yRjy");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4deefa30_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RTXSpinner_vue__ = __webpack_require__("b/xm");
function injectStyle (ssrContext) {
  __webpack_require__("D1Mp")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-4deefa30"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RTXSpinner_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4deefa30_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RTXSpinner_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "oMLH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
   data: function data() {
      return {
         msg: ''
      };
   },

   methods: {
      preventMouseDown: function preventMouseDown(e) {}
   }
});

/***/ }),

/***/ "oNiF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TabBar_vue__ = __webpack_require__("myor");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a8484468_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TabBar_vue__ = __webpack_require__("LMa+");
function injectStyle (ssrContext) {
  __webpack_require__("idgZ")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-a8484468"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TabBar_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a8484468_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TabBar_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "rhJX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Entry_vue__ = __webpack_require__("HSuB");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: "Tiles",
  components: { Entry: __WEBPACK_IMPORTED_MODULE_0__Entry_vue__["a" /* default */] },
  props: {
    feed: {
      type: Array,
      required: true
    }
  },
  computed: {
    // Chunk the feed into groups of 14 items
    chunkedFeed: function chunkedFeed() {
      var result = [];
      for (var i = 0; i < this.feed.length; i += 14) {
        result.push(this.feed.slice(i, i + 14));
      }
      return result;
    }
  }
});

/***/ }),

/***/ "rxWM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"entry",class:{ 'no-click': _vm.tileType === 'single' },on:{"click":_vm.handleClick}},[_c('div',{staticClass:"entry-body"},[_c('div',{staticClass:"heading-image",style:(_vm.headingImageStyle)}),_vm._v(" "),_c('div',{staticClass:"heading"},[_c('div',{staticClass:"title",class:_vm.titleClampClass},[_vm._v("\n            "+_vm._s(_vm.entry.entry.content.title)+"\n         ")]),_vm._v(" "),_c('div',{staticClass:"stats"},[_vm._v("\n            "+_vm._s(_vm.likesCount)+"\n         ")]),_vm._v(" "),_c('div',{staticClass:"meta clamp-two-lines"},[_vm._v("\n            "+_vm._s(_vm.entry.entry.content.channelTitle)+"\n         ")]),_vm._v(" "),_c('a',{staticClass:"plain-link",attrs:{"href":_vm.composeSourceURL()},on:{"click":function($event){$event.stopPropagation();}}},[_c('div',{staticClass:"source"},[_vm._v("YouTube")])])]),_vm._v(" "),(_vm.shouldShowComments)?_c('div',{staticClass:"entry-comments",style:({ minHeight: _vm.commentsMinHeight })},_vm._l((_vm.displayedComments),function(c,idx){return _c('Comment',{key:idx,attrs:{"comment":c}})}),1):_vm._e()]),_vm._v(" "),(_vm.showExtraStats)?_c('div',{staticClass:"extra-stats"},[_vm._v("\n      "+_vm._s(_vm.extraStatsText)+"\n   ")]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "t7h/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"footer-row"},[_c('a',{attrs:{"tabindex":"0","href":"/privacy"}},[_vm._v("PRIVACY")]),_vm._v(" | "),_c('a',{attrs:{"tabindex":"0","href":"/legal"}},[_vm._v("LEGAL")]),_vm._v(" "),_c('br'),_c('br'),_vm._v("\n   COPYRIGHT © "+_vm._s(_vm.copyrightYear)+" COMPANY INC.\n   "),_c('br'),_vm._v("\n   ALL RIGHTS RESERVED.\n")])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "toJh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tiles"},_vm._l((_vm.chunkedFeed),function(group,gIndex){return _c('div',{key:gIndex,staticClass:"tile-group"},[(group[0])?_c('div',{staticClass:"row row-1"},[_c('Entry',{staticClass:"tile tile-full",attrs:{"entry":group[0],"tileType":"tile","maxComments":2}})],1):_vm._e(),_vm._v(" "),(group[1] || group[2])?_c('div',{staticClass:"row row-2 grid-two"},[(group[1])?_c('Entry',{staticClass:"tile",attrs:{"entry":group[1],"tileType":"tileOneLine","maxComments":1}}):_vm._e(),_vm._v(" "),(group[2])?_c('Entry',{staticClass:"tile",attrs:{"entry":group[2],"tileType":"tileOneLine","maxComments":1}}):_vm._e()],1):_vm._e(),_vm._v(" "),(group[3])?_c('div',{staticClass:"row row-3"},[_c('Entry',{staticClass:"tile tile-full",attrs:{"entry":group[3],"tileType":"tile","maxComments":3}})],1):_vm._e(),_vm._v(" "),(group[4] || group[5])?_c('div',{staticClass:"row row-4 grid-two"},[(group[4])?_c('Entry',{staticClass:"tile",attrs:{"entry":group[4],"tileType":"tileOneLine","maxComments":2}}):_vm._e(),_vm._v(" "),(group[5])?_c('Entry',{staticClass:"tile",attrs:{"entry":group[5],"tileType":"tileOneLine","maxComments":2}}):_vm._e()],1):_vm._e(),_vm._v(" "),(group[6] || group[7] || group[8])?_c('div',{staticClass:"row row-5 grid-two stack-mix"},[_c('div',{staticClass:"stacked-two"},[(group[6])?_c('Entry',{staticClass:"tile stacked",attrs:{"entry":group[6],"tileType":"tile","maxComments":1}}):_vm._e(),_vm._v(" "),(group[7])?_c('Entry',{staticClass:"tile stacked",attrs:{"entry":group[7],"tileType":"tile","maxComments":1}}):_vm._e()],1),_vm._v(" "),(group[8])?_c('Entry',{staticClass:"tile tall",attrs:{"entry":group[8],"tileType":"tile","maxComments":3}}):_vm._e()],1):_vm._e(),_vm._v(" "),(group[9] || group[10] || group[11])?_c('div',{staticClass:"row row-6 grid-two stack-mix"},[(group[9])?_c('Entry',{staticClass:"tile tall",attrs:{"entry":group[9],"tileType":"tile","maxComments":3}}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"stacked-two"},[(group[10])?_c('Entry',{staticClass:"tile stacked",attrs:{"entry":group[10],"tileType":"tile","maxComments":1}}):_vm._e(),_vm._v(" "),(group[11])?_c('Entry',{staticClass:"tile stacked",attrs:{"entry":group[11],"tileType":"tile","maxComments":1}}):_vm._e()],1)],1):_vm._e(),_vm._v(" "),(group[12] || group[13])?_c('div',{staticClass:"row row-7 grid-two small-font"},[(group[12])?_c('Entry',{staticClass:"tile",attrs:{"entry":group[12],"tileType":"tile","maxComments":0}}):_vm._e(),_vm._v(" "),(group[13])?_c('Entry',{staticClass:"tile",attrs:{"entry":group[13],"tileType":"tile","maxComments":0}}):_vm._e()],1):_vm._e(),_vm._v(" "),(group[14])?_c('div',{staticClass:"row row-8"},[_c('Entry',{staticClass:"tile tile-full",attrs:{"entry":group[14],"tileType":"tile","maxComments":2}})],1):_vm._e()])}),0)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "uODH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('router-view')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "vYcq":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "xoEG":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "yRjy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
   name: 'RTXSpinner'
});

/***/ }),

/***/ "zP1w":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "zoSL":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.b160750da5ecf11654da.js